export const DATE_RANGE = {
  LAST_30_DAYS: 1,
  THIS_MONTH: 2,
  MONTHS_3: 3,
  MONTHS_6: 4,
  YEAR: 5
};

export const DATE_RANGE_LABEL = {
  [DATE_RANGE.LAST_30_DAYS]: "general.calendar.last_30_days",
  [DATE_RANGE.THIS_MONTH]: "general.calendar.this_month",
  [DATE_RANGE.MONTHS_3]: "general.calendar.last_3_months",
  [DATE_RANGE.MONTHS_6]: "general.calendar.last_6_months",
  [DATE_RANGE.YEAR]: "general.calendar.yearly"
};
